module.exports = __webpack_public_path__ + "img/territory_map_cadastre.64c55840.svg";